

<template>




<van-image 
v-if="StoreDiametreCoAChoose && StoreCodeRefCoA != 'NU'"
  width="100%"
  class="img_maquette_cable"
  position="left"
  v-bind:src="StoreApi +'/images/co_a/'+ LoadImageCoA +'.png'"
  :show-loading = false
/> 


    <van-image v-if="!StoreDiametreCoAChoose"
  width="100%"
  class="opacity_low img_maquette_cable"
  position="left"
  v-bind:src="StoreApi +'/images/co_a/8yK_M1_FC.png'"
  :show-loading = false
/> 

 
        </template>

        <script>
        export default {
          components: {
          },
          data() {
            return {
              nbFibreSupp12: false,
              link: null
            }
          },
          created(){
          },
          computed: {
                /** api APP */
                StoreApi() {
                  return this.$store.state.storeGlobal.StoreApi
                  },
                  /** diametre choisie ok */
                  StoreDiametreCoAChoose() {
                    return this.globalFunction.existKeyInArray("diametre",  this.$store.state.storeCoA.coA) 
                        ?  true
                        :  false

                    
                },
                /** Type de diametre */
                StoreTypeDiametreCoA() {
                    return this.$store.state.storeCoA.coA.diametre.typeDiametre
                },

                 /** Type de câble */
                 StoreTypeFibreCodeRef() {
                    return this.$store.state.storeCable.cable.type.TypeFibreCodeRef
                },

                /** Type de connecteur coté A */
                StoreCodeRefCoA() {
                    return this.$store.state.storeCoA.coA.type.codeRefCoA
                },

                 /** Nombre de fibre */
                 StoreNbFibre() {
                    return this.$store.state.storeCable.cable.nombre.nbFibre
                },

              

              /**** Fonction pour chargement de l'image du connecteur a */
                LoadImageCoA(){
               
                    return this.StructureLinkImage
                },

                getLinkNombreFibre(){
                  if(this.StoreNbFibre == 24 ){
                    return 12;
                  }
                  else{
                    return this.StoreNbFibre
                  }

                },

                getLinkDiametreFibre(){
                  if(this.StoreTypeDiametreCoA == "2mm" ){
                    return 'yK';
                  }else if(this.StoreTypeDiametreCoA == "900µ" ){
                    return 'yE'
                  }
                  else{
                    return 'error';
                  }

                },

                StructureLinkImage(){
                  return this.getLinkNombreFibre + this.getLinkDiametreFibre + '_' + this.StoreTypeFibreCodeRef + '_' + this.StoreCodeRefCoA
               },

          }
        
        
        }
</script>